import React from 'react';
import { CheckCircle } from 'lucide-react';

const BookingProgressSteps = ({ steps, currentStep }) => {
  return (
    <div className="mb-6 sm:mb-8">
      <div className="flex items-center justify-between overflow-x-auto pb-1">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className="flex flex-shrink-0 items-center">
              <div
                className={`flex h-8 w-8 items-center justify-center rounded-full border text-xs font-medium transition-colors ${
                  currentStep >= step.id
                    ? 'border-m-ink bg-m-ink text-white'
                    : 'border-m-border-light bg-m-surface text-m-ink-faint'
                }`}
              >
                {currentStep > step.id ? (
                  <CheckCircle className="h-3.5 w-3.5" />
                ) : (
                  step.id
                )}
              </div>
              <span
                className={`ml-2.5 hidden text-sm font-medium sm:inline ${
                  currentStep >= step.id ? 'text-m-ink' : 'text-m-ink-faint'
                }`}
              >
                {step.title}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`mx-2 h-px min-w-[16px] flex-1 sm:mx-3 ${
                  currentStep > step.id ? 'bg-m-ink' : 'bg-m-border-light'
                }`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default BookingProgressSteps;
